// bibdocumentoautorservice.ts
import { BibDocumentoAutorModel } from '@/models/biblioteca/bibdocumento/bibdocumentoautor.model';
import api from '@/services/axios/api';
import { AxiosResponse } from 'axios';
import { DataSource } from '@/datasources/consulte-grid';
import { RegisterOutput } from '@/models/register-output';
import bibdocumentoService from './bibdocumento.service';

class BibDocumentoAutorService {
  private readonly baseUrl = '/BibDocumentoAutor';
 
 async get(id: number): Promise<BibDocumentoAutorModel | null> {
  try {
    const res = await api.get<BibDocumentoAutorModel>(`${this.baseUrl}/${id}`);
    return res.data;
  } catch (e: any) {
    if (e?.response?.status === 204) return null;
    throw e;
  }
}


 atualizar(BibDocumentoAutor: BibDocumentoAutorModel): Promise<AxiosResponse> {
  return api.put(this.baseUrl, BibDocumentoAutor);
 }

}

export default new BibDocumentoAutorService();
